import { Tag } from 'antd';
import React, { useMemo, useState } from 'react';
import {
  ReferralEdit as ReferralEditIcon,
  ReferralGlobal as ReferralGlobalIcon,
  ReferralExclamationCircle as ReferralExclamationCircleIcon,
} from 'common/components/svgs';
import { dayFormatType, formatDay } from '~helpers/day';
import { useTranslation } from 'react-i18next';
import formatPrice from '~helpers/currency';
import showElementByAuth from '~helpers/auth';
import { platformEntity, entityAction } from '~constants';

export default function CommissionPlanCard({ data, handleEditPlan }) {
  const [showMoreTier, setShowMoreTier] = useState(false);
  const { t } = useTranslation();
  const termUnitLabel = useMemo(() => {
    const calculationType = data.tiers[0]?.calculationRules[0]?.calculationType;
    switch (calculationType) {
      case 'PERCENTAGE':
        return '%';
      case 'VALUE':
        return data.currency;
      default:
        return '';
    }
  }, [data]);
  return (
    <>
      <div className="commison-plan__plan-card">
        <div className="commison-plan__plan-card__basic-info">
          {!data.countryHasDefault ? (
            <div className="commison-plan__plan-card__basic-info__no-default-warning commison-plan__plan-card--mb-8">
              <ReferralExclamationCircleIcon className="commison-plan__plan-card__basic-info__no-default-warning__icon" />
              {t('cms.referral.commission_plan.list_card.no_default_warning')}
            </div>
          ) : null}

          <div className="commison-plan__plan-card__basic-info__country commison-plan__plan-card--mb-12">
            <ReferralGlobalIcon className="commison-plan__plan-card__basic-info__country__icon" />
            {data.country.name}
          </div>

          <div className="commison-plan__plan-card--mb-12">
            <div className="commison-plan__plan-card__basic-info__name commison-plan__plan-card--mb-8">
              <span>
                {data.name} ({data.externalName})
              </span>
              {data.default ? (
                <Tag className="commison-plan__plan-card__basic-info__default-tag">
                  {t('cms.referral.commission_plan.list_card.tag.default')}
                </Tag>
              ) : null}
            </div>
            <span className="commison-plan__plan-card__basic-info__time">
              {formatDay(dayFormatType.UKWITHHM, data.updatedAt)}, by {data.updatedUser.firstName}{' '}
              {data.updatedUser.lastName}
            </span>
          </div>

          <If
            condition={showElementByAuth(
              platformEntity.REFERRAL_COMMISSION_PLAN,
              entityAction.UPDATE,
            )}
          >
            <div className="commison-plan__plan-card__link" onClick={() => handleEditPlan(data)}>
              <ReferralEditIcon className="commison-plan__plan-card__link__icon" />
              {t('cms.referral.commission_plan.list_card.btn.edit')}
            </div>
          </If>
        </div>
        <div className="commison-plan__plan-card__tier-info">
          <div>
            <div className="commison-plan__plan-card__tier-info__row commison-plan__plan-card__tier-info--mb-12">
              <div className="commison-plan__plan-card__tier-info__col--wide">
                <span className="commison-plan__plan-card__tier-info__th">
                  {t('cms.referral.commission_plan.list_card.no.label')}
                </span>
              </div>
              <div className="commison-plan__plan-card__tier-info__col commison-plan__plan-card--text-right commison-plan__plan-card--pl-8">
                <span className="commison-plan__plan-card__tier-info__th">
                  {t('cms.referral.commission_plan.list_card.long_term.label')} ({termUnitLabel})
                </span>
              </div>
              <div className="commison-plan__plan-card__tier-info__col commison-plan__plan-card--text-right commison-plan__plan-card--pl-8">
                <span className="commison-plan__plan-card__tier-info__th">
                  {t('cms.referral.commission_plan.list_card.short_term.label')} ({termUnitLabel})
                </span>
              </div>
            </div>
            <For of={showMoreTier ? data.tiers : data.tiers.slice(0, 3)} each="tier" index="index">
              <div
                className="commison-plan__plan-card__tier-info__row commison-plan__plan-card__tier-info--mb-12"
                key={index}
              >
                <div className="commison-plan__plan-card__tier-info__col--wide commison-plan__plan-card--flex">
                  <span className="commison-plan__plan-card__tier-info__td">
                    {data.tiers.length - 1 === index && tier.bookingCountTo === null
                      ? `≥ ${tier.bookingCountFrom}`
                      : `${tier.bookingCountFrom} - ${tier.bookingCountTo}`}
                  </span>
                  <Tag title={tier.name} className="commison-plan__plan-card__tier-info__tag">
                    {tier.name}
                  </Tag>
                </div>
                <div className="commison-plan__plan-card__tier-info__col commison-plan__plan-card--text-right commison-plan__plan-card--pl-8">
                  <span className="commison-plan__plan-card__tier-info__td">
                    {formatPrice(tier.longTermCalculationValue).slice(1)}
                  </span>
                </div>
                <div className="commison-plan__plan-card__tier-info__col commison-plan__plan-card--text-right commison-plan__plan-card--pl-8">
                  <span className="commison-plan__plan-card__tier-info__td">
                    {formatPrice(tier.shortTermCalculationValue).slice(1)}
                  </span>
                </div>
              </div>
            </For>
          </div>
          {data.tiers.length > 3 ? (
            <span
              className="commison-plan__plan-card__link"
              onClick={() => setShowMoreTier(!showMoreTier)}
            >
              {showMoreTier
                ? t('cms.referral.commission_plan.list_card.btn.view_less')
                : t('cms.referral.commission_plan.list_card.btn.view_more')}
            </span>
          ) : null}
        </div>
      </div>
    </>
  );
}
